import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  changeQueryParams,
  selectItemsIds,
  selectPagination,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';

import TasksHeaderSort from 'components/Tasks/TasksHeaderSort';
import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';
import TasksToExecutorsListItem from './TasksToExecutorsListItem';
import PaginationNextPrev from '../../Common/PaginationNextPrev';

const tasksCollectionRName =
  'tasksModule.collections.tasksToExecutorsCollection';

// eslint-disable-next-line react/prefer-stateless-function
const TasksToExecutorsList = props => {
  let comments;
  if (props.requestStatus.inProgress) {
    comments = <MediumPreLoader />;
  } else if (props.itemsIds.length > 0) {
    comments = (
      <React.Fragment>
        {props.itemsIds.map(itemId => {
          const task = props.selectItemById(itemId);
          if (task) {
            return (
              <TasksToExecutorsListItem
                key={`taskItemAsOwner${itemId}`}
                task={task}
                isTaskFromAuthUser={
                  props.authUserId.toString() === task.owner.id.toString()
                }
                onRefreshParentContent={props.sendRequest}
              />
            );
          }
          return null;
        })}
        <PaginationNextPrev
          currentPageCount={props.itemsIds.length}
          paginationData={props.paginationData}
          handlePageClick={pageNumber => {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            props.changeQueryParams({ page: pageNumber });
            props.sendRequest();
          }}
        />
      </React.Fragment>
    );
  } else {
    comments = (
      <div className="alert alert-default text-center">
        <p>{t('Задания, соответствующие вашим требованиям, не найдены')} :-(</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <TasksHeaderSort listReduceName={props.reducerName} />
      {comments}
    </React.Fragment>
  );
};

TasksToExecutorsList.propTypes = {
  // IN
  reducerName: PropTypes.string.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestStatus: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  authUserId: PropTypes.string.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  authUserId: `${selectUserId(state)}`,
  requestStatus: selectRequestState(state, props.reducerName),
  paginationData: selectPagination(state, props.reducerName),
  itemsIds: selectItemsIds(state, props.reducerName),
  selectItemById: id => selectItemById(state, tasksCollectionRName, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.reducerName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.reducerName, queryParams))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksToExecutorsList)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksToExecutorsList/index.js